import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from '../../../base/base-step.component';
import { isNullOrUndefined } from 'util';
import { AbrirRecursoComponent } from 'app/Componentes/abrir-recurso/abrir-recurso.component';
import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { GerenciamentoCurso } from 'app/entity/gerenciamento-curso.model';


@Component({
    selector: 'gerenciamento-curso-etapa1',
    templateUrl: './gerenciamento-curso-etapa1.component.html',
})
export class CrudGerenciamentoCursoEtapa1Component extends BaseStepComponent {

    @Input() listaResumo: any[] = [];
    @Input() listaRelatores: any[];
    @Input() listaConteudo: any[] = [];
    @Output() listaConteudoChange = new EventEmitter<any[]>();
    @Input() listaCapacitadora: SelectItem[] = [];
    @Input() listaAbrangencia: SelectItem[] = [];
    @Input() listaModalidade: SelectItem[] = [];
    @Input() listaTipoAtividade: SelectItem[] = [];
    @Input() listaAreaTematica: SelectItem[] = [];
    @Input() listaPublicoAlvo: SelectItem[] = [];
    @Input() listaCriterioAvaliacao: SelectItem[] = [];
    @Input() validateForm: any = false;
    @Output() validateFormChange = new EventEmitter<any>();
    @Input() codigo: string;
    @Input() listaBibliografia: any[] = [];
    @Output() listaBibliografiaChange = new EventEmitter<any[]>();

    @Input() storagedListFiles: any[];
    @Output() uploadedFilesChange = new EventEmitter<any>();
    @Input() uploadedFiles: any[];
    uploadedFilesRecurso: any[] = [];
    @Input() recurso: RecursoFiltro;

    uploadedFilesTemp: any[] = [];
    dataHoje: Date;
    dataMinima : Date;
    @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);

    exibirAvisoReplica:boolean = this.service.deveExibirAvisoReplica();

    dadosReplicadosCurso: GerenciamentoCurso;


    ngOnInit() {
        const replicado = this.activatedRoute.snapshot.queryParams['replicado'];
        
        if (replicado !== 'true') {
          this.service.limparCursoReplicado();
          this.exibirAvisoReplica = false;
        }else{
            this.exibirAvisoReplica = true;
        }

        this.dadosReplicadosCurso = this.service.obterCursoReplicado();
    
        this.init();
      }

    init() {        
        if (this.uploadedFiles.length > 0) {
            this.uploadedFilesTemp = [];
            this.uploadedFiles.forEach(i => {
                i.show = true;
                this.uploadedFilesTemp.push(i);
            });
            this.uploadedFiles = [];
            this.uploadedFiles = this.uploadedFilesTemp;
        }
        
        this.dataHoje = new Date();
        
        this.uploadedFilesChange.emit(this.uploadedFiles);
        
        this.stepObject.emit(this);
        this.emitValidation(true);

        this.carregarDadosCopiados(this.dadosReplicadosCurso)
    

    }

    selecionaArquivo(event: any, val: number) {
        for (const file of event.files) {
            if (file.name.match(/.pdf/) || file.name.match(/.jpg/) || file.name.match(/.png/)) {
                this.IncluirArquivo(file, this.uploadedFiles,
                    this.uploadedFilesChange, { idCurso: this.cadastro.get('curso.id').value, tipo: val })
            }
        }
    }

    removeElementList(value: any, tipo: number) {
        this.uploadedFiles.forEach((item, index) => {
            if (item.nome_arquivo === value.file.name && item.id < 1) {
                super.removeFromList(this.uploadedFiles,
                    this.uploadedFilesChange, index, 'anexos');

            }
        });
    }

    addToListBibliografia(list: any, listEmit: EventEmitter<any>, form: any, event: any, validationObj: any = null, customData: any = null) {
        if (form.controls.bibliografia.value == null || isNullOrUndefined(form.controls.bibliografia.value)) {
            this.showMsgWarn('Campo bibliografia vazio.');
            return;
        }
        if (validationObj != null && this.validateListExists(list, validationObj)) { return false; }
        if (form.valid) {
            list.push(Object.assign({}, form.value, customData));
            list = [...list];
            listEmit.emit(list);

            form.reset();
            this.touchAll(form, 'markAsPristine');
        } else {
            this.touchAll(form);
            return false;
        }
    }

    setArquivos(ev) {
        if (ev) {
            this.uploadedFiles = ev.value;
        }
    }

    emitValidation(isInit = false) {
        if (isInit) {
            this.validateForm = [];
        } else {
            const countListaArquivos = this.uploadedFiles.filter(item => item.tipo == 1).length;
            if (this.cadastro.get('curso').valid && this.listaConteudo.length > 0 &&
                this.cadastro.controls.curso.get('bibliografia_curso').valid && this.listaBibliografia.length > 0 &&
                this.cadastro.get('observacao').valid) {
                this.isValid = true;
            } else {
                this.isValid = false;
                this.validateForm = [this.cadastro.get('curso'), this.cadastro.get('observacao')];
                if (this.listaConteudo.length == 0) {
                    this.validateForm = [this.cadastro.get('curso'), this.cadastro.get('conteudo')];
                    this.showMsgWarn('É necessária a inclusão de ao menos um Conteúdo');
                } else if (this.cadastro.get('observacao').get('observacao').value == false) {
                    this.showMsgWarn('<p>É necessário informar uma observação!</p>')
                } else if (this.listaBibliografia.length == 0) {
                    this.showMsgWarn('Informe ao menos uma bibliografia');
                } else {
                    this.showMsgWarn('É necessário o prenchimento dos campos obrigatórios ');
                }
            }
        }
        setTimeout(() => this.validateFormChange.emit(this.validateForm), 0);
        this.isValidChange.emit(this.isValid);
    }


    carregarDadosCopiados(dadosReplicadosCurso: GerenciamentoCurso) {
        const idPublicoAlvo = this.extrairPropriedade(dadosReplicadosCurso.curso_publico_alvo, 'id_publico_alvo');
        const idAreaTematica = this.extrairPropriedade(dadosReplicadosCurso.curso_area_tematica, 'id_area_tematica');
        const idCriterioAvalicao = this.extrairPropriedade(dadosReplicadosCurso.curso_criterio_avaliacao, 'id_criterio_avaliacao')
        
        const camposCurso = {
            'curso.id_capacitadora': dadosReplicadosCurso.id_capacitadora,
            'curso.titulo_original': dadosReplicadosCurso.titulo_original,
            'curso.titulo_traduzido': dadosReplicadosCurso.titulo_traduzido,
            'curso.carga_horaria': dadosReplicadosCurso.carga_horaria,
            'curso.frequencia_minima': dadosReplicadosCurso.frequencia_minima,
            'curso.id_abrangencia': dadosReplicadosCurso.id_abrangencia,
            'curso.id_modalidade': dadosReplicadosCurso.id_modalidade,
            'curso.codigo_curso_capacitadora': dadosReplicadosCurso.codigo_curso_capacitadora,
            'curso.id_tipo_atividade': null,
            'curso.curso_area_tematica.list': idAreaTematica,
            'curso.curso_publico_alvo.list': idPublicoAlvo,
            'curso.curso_criterio_avaliacao.list': idCriterioAvalicao,
            'curso.conteudo': dadosReplicadosCurso.conteudo,    
            'curso.bibliografia_curso': dadosReplicadosCurso.bibliografia_curso 
        };

        this.listaConteudo = dadosReplicadosCurso.conteudo
        this.listaBibliografia = dadosReplicadosCurso.bibliografia_curso

        this.listaConteudoChange.emit(this.listaConteudo);
        this.listaBibliografiaChange.emit(this.listaBibliografia);


        this.atualizarCamposCadastro(camposCurso);
    }

    extrairPropriedade(lista: any[], propriedade: string): any[] {
        if (!lista || !Array.isArray(lista)) {
            return [];
        }
        return lista.map(function (item) {
            return item[propriedade];
        });
    }

    atualizarCamposCadastro(campos: { [key: string]: any }) {
        setTimeout(() => { 
            Object.keys(campos).forEach(campo => {
                const formControl = this.cadastro.get(campo);
                if (formControl) {
                    formControl.setValue(campos[campo] || '');
                    formControl.markAsTouched(); 
                    formControl.markAsDirty();
                    formControl.updateValueAndValidity();
                } else {
                    console.log(`Campo não encontrado no formulário: ${campo}`);
                }
            });
            this.cadastro.updateValueAndValidity();
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/gerenciamento-curso/crud/etapas/gerenciamento-curso-etapa1.component.ts